// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前用户信息 GET /api/v1/admininfo */
export async function queryCurrentUser(options?: { [key: string]: any }) {
  return request<API.CurrentUserResult>('/api/v1/admininfo', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 新获取管理员信息 */
// export async function newGetAdminInfo(options?: { [key: string]: any }) {
//   return request<API.AdminInfo>('/api/v1/logininfo', {
//     method: 'GET',
//     ...(options || {}),
//   });
// }

export async function updateRule(options?: { data?: API.RuleListItem; [key: string]: any }) {
  // 空实现，不执行任何操作
  return {};
}

export async function removeRule(options?: { data?: { key: string[] }; [key: string]: any }) {
  // 空实现，不执行任何操作
  return {};
}

export async function rule(options?: { [key: string]: any }) {
  // 空实现，不执行任何操作
  return {};
}

export async function addRule(options?: { data?: API.RuleListItem; [key: string]: any }) {
  // 空实现，不执行任何操作
  return {};
}
